import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined'
import { Card, CardActionArea, Chip, Stack, Typography, useTheme } from '@mui/material'
import { useState } from 'react'
import { WQISignal } from '../../../store/waterQualityIndex'
import { WQIParameterDrawer } from './WQIParameterDrawer'

interface WQIParameterResultProps {
  contributor: WQISignal
}

export const WQIParameterResult = ({ contributor }: WQIParameterResultProps) => {
  const [drawerOpen, setDrawerOpen] = useState(false)
  const theme = useTheme()

  const handleClick = () => {
    setDrawerOpen(true)
  }

  // Determine status label and colors based on severity
  const getStatusConfig = () => {
    const { severity } = contributor

    switch (severity) {
      case 'action':
        return {
          label: 'Take action',
          color: theme.palette.error.main,
          backgroundColor: theme.palette.error.light,
        }
      case 'monitor':
        return {
          label: 'Monitor',
          color: theme.palette.warning.main,
          backgroundColor: theme.palette.warning.light,
        }
      case 'safe':
      default:
        return {
          label: 'Normal',
          color: theme.palette.success.main,
          backgroundColor: theme.palette.success.light,
        }
    }
  }

  const statusConfig = getStatusConfig()

  // Format signal key to display name (e.g., "nitrate_nitrite_infant_risk" -> "Nitrate Nitrite Infant Risk")
  const formatSignalName = (signalKey: string) => {
    return signalKey
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  }

  return (
    <>
      <Card
        variant="outlined"
        sx={{
          borderRadius: 2,
          p: 1,
          border: `1px solid ${theme.palette.grey[200]}`,
        }}
      >
        <CardActionArea onClick={handleClick} sx={{ p: 2 }}>
          <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
            <Stack spacing={0.5} sx={{ flex: 1 }}>
              <Stack direction="row" spacing={2} alignItems="center">
                <Typography variant="h6" fontWeight={600} color="text.primary">
                  {contributor.statement || formatSignalName(contributor.signalKey)}
                </Typography>
                <Chip
                  label={
                    <Stack direction="row" spacing={1} alignItems="center">
                      <div
                        style={{
                          width: '6px',
                          height: '6px',
                          borderRadius: '50%',
                          backgroundColor: 'currentColor',
                          marginRight: '4px',
                        }}
                      />
                      {statusConfig.label}
                    </Stack>
                  }
                  sx={{
                    color: statusConfig.color,
                    backgroundColor: statusConfig.backgroundColor,
                  }}
                  size="small"
                />
              </Stack>
              <Typography variant="body2" color="text.secondary">
                {contributor.whyItMatters}
              </Typography>
            </Stack>
            <ArrowForwardIosOutlinedIcon
              sx={{ color: theme.palette.grey[400], fontSize: '16px', mt: 0.5 }}
            />
          </Stack>
        </CardActionArea>
      </Card>
      <WQIParameterDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        signal={contributor}
      />
    </>
  )
}
